import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SolutionDetail from "@/pages/SolutionDetail";

export const Route = createFileRoute("/zh-cn/industries/pharma-biotech/$slug")({
  head: ({ params }) => buildRouteHead(`/zh-cn/industries/pharma-biotech/${params.slug}`),
  component: SolutionDetail,
});

